import { render } from "./AvatarSidebar.vue?vue&type=template&id=57cc04c4"
import script from "./AvatarSidebar.vue?vue&type=script&lang=js"
export * from "./AvatarSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__